




























































import {
  defineComponent,
  ref,
  useFetch,
  useContext
} from '@nuxtjs/composition-api';
import { useImage } from '@wemade-vsf/composables'
import { SfImage, SfHeading } from '@storefront-ui/vue'
import SkeletonLoader from 'components/theme/SkeletonLoader.vue';

export default defineComponent({
  name: 'EmployeeGrid',
  props: {
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: String,
      default: '4'
    },
    showType: {
      type: String,
      default: 'all'
    },
    employeeIds: {
      type: String,
      default: ''
    },
    customEmailText: {
      type: String,
      default: ''
    }
  },
  components: {
    SfHeading,
    SfImage,
    SkeletonLoader
  },
  setup (props) {
    const { app } = useContext()
    const loading = ref(true)
    const employees = ref(null)
    const { imageSizes, getMagentoImage } = useImage()

    const imageWidth = imageSizes?.card?.width ?? 400
    const imageHeight = imageSizes?.card?.height ?? 400

    const placeholders = props.showType === 'custom' ? props.employeeIds.split(',').length : parseInt(props.columns)

    useFetch(async () => {
      let params = {
        filter: {
          is_active: { eq: '1'}
        },
        currentPage: 1,
        pageSize: 100
      }
      if (props.employeeIds && props.showType === 'custom') {
        const ids = props.employeeIds.split(',')
        params.filter['employee_id'] = { in: ids }
        params.pageSize = ids.length
      }

      const { data } = await app.$vsf.$magento.api.employees(params)
      employees.value = data?.WmEmployees?.items || []
      loading.value = false
    })

    return {
      imageWidth,
      imageHeight,
      getMagentoImage,
      loading,
      placeholders,
      employees
    }
  }
})
